import store from '@/store'

import { computed } from '@vue/composition-api'

export default function useCalendarSidebar() {
  // ------------------------------------------------
  // originOptions
  // ------------------------------------------------
  const newsTypeOptions = computed(() => store.state.calendar.newsType)
  const disclosureTypeOptions = computed(() => store.state.calendar.disclosureType)
  const originOptions = computed(() => store.state.calendar.origins)
  const regionOptions = computed(() => store.state.calendar.regions)
  
  // ------------------------------------------------
  // selectedOrigins
  // ------------------------------------------------
  const selectedNewsType = computed({
    get: () => store.state.calendar.selectedNewsType,
    set: val => {
      store.commit('calendar/SET_SELECTED_NEWS_TYPE', val)
    },
  })
  const selectedOrigins = computed({
    get: () => store.state.calendar.selectedOrigins,
    set: val => {
      store.commit('calendar/SET_SELECTED_ORIGINS', val)
    },
  })
  const selectedDisclosureType = computed({
    get: () => store.state.calendar.selectedDisclosureType,
    set: val => {
      store.commit('calendar/SET_SELECTED_DISCLOSURE_TYPE', val)
    },
  })

  // ------------------------------------------------
  // checkAll
  // ------------------------------------------------
  const checkAll = computed({
    /*
      GET: Return boolean `true` => if length of options matches length of selected filters => Length matches when all events are selected
      SET: If value is `true` => then add all available options in selected filters => Select All
           Else if => all filters are selected (by checking length of both array) => Empty Selected array  => Deselect All
    */
    get: () => selectedOrigins.value.length === originOptions.value.length,
    set: val => {
      if (val) {
        selectedOrigins.value = originOptions.value.map(i => i.id)
      } else if (selectedOrigins.value.length === originOptions.value.length) {
        selectedOrigins.value = []
      }
    },
  })

   return {
    newsTypeOptions,
    selectedNewsType,
    disclosureTypeOptions,
    selectedDisclosureType,
    originOptions,
    regionOptions,
    selectedOrigins,
    checkAll,
  }
}
